export const PROVIDER_TYPES = {
    OPENAI: 'openai',
    AZURE_OPENAI: 'azure-openai',
    BRING_YOUR_OWN_LLM: 'bring-your-own-llm',
    SELECT_PROVIDER: 'select-provider',
} as const;

export const DEFAULT_MODELS = {
    QUERY_PARSING: 'gpt-5.5-2026-04-23',
    VIZ_AND_CALC: 'gpt-5.5-2026-04-23',
    EMBEDDINGS: 'text-embedding-3-small',
} as const;

export const GAI_QUERY_PARSING_MODEL_SITE_SETTING = 'settings.siteSettingsV2.generativeAiQueryParsingModel';
export const GAI_VIZ_AND_CALC_GENERATION_MODEL_SITE_SETTING = 'settings.siteSettingsV2.generativeAiVizAndCalcGenerationModel';
export const GAI_EMBEDDINGS_MODEL_SITE_SETTING = 'settings.siteSettingsV2.generativeAiEmbeddingsModel';
export const GAI_IS_DEFAULT_ONLINE_MODELS = 'settings.siteSettingsV2.generativeAiIsDefaultOnlineModels';

export const AUTH_MODES = {
    NONE: 'None',
    API_KEY: 'ApiKey',
    OAUTH: 'OAuth',
} as const;
export type AuthMode = typeof AUTH_MODES[keyof typeof AUTH_MODES];
export const GAI_LLM_AUTH_MODE = 'settings.siteSettingsV2.onPremLLMAuthMode';
export const GAI_LLM_OAUTH_CONFIG_ID = 'settings.siteSettingsV2.onPremLLMOAuthConfigId';